import { KeyWordLandingPage } from '../../types';
import { MetaDataContext } from './types';

type Props = {
  data: {
    keywordLandingPage: KeyWordLandingPage;
  };
};

export default ({ data }: Props, { t }: MetaDataContext) => {
  return {
    title: t('meta', 'keyword-search-page.title', {
      keyword: data.keywordLandingPage.title,
    }),
    description: t('meta', 'keyword-search-page.description', {
      keyword: data.keywordLandingPage.title,
      categories: data.keywordLandingPage.categories
        ?.map(({ name }) => name)
        .join(' '),
    }),
  };
};
